import { createBrowserRouter } from "react-router";
import RootLayout from "src/layouts/RootLayout";
import StandAloneLayout from "src/layouts/StandAloneLayout";
import CookiePolicy from "src/pages/CookiePolicy/CookiePolicy";
import DashboardPage from "src/pages/Dashboard/DashbordPage/DashboardPage";
import InvitationExpiryPage from "src/pages/InvitationExpiry/invitationExpiryPage";
import NotFound from "src/pages/NotFound/NotFound";
import OrganisationInfoPage from "src/pages/OrganisationInfo/OrganisationInfoPage";
import UserInfoPage from "src/pages/UserInfo/UserInfoPage";

import OrganisationBooking from "@components/OrganisationBooking/OrganisationBooking";
import OrganisationInfo from "@components/OrganisationInfo/OrganisationInfo";
import { ProfileInfo } from "@components/User/ProfileInfo/ProfileInfo";
import Reservations from "@components/User/Reservations/Reservations";
import { organisationEnum, routeEnum, userInfoEnum } from "@enums/route.enum";

import RequireAuth from "./RouteAuth";

export const router = createBrowserRouter([
  {
    children: [
      { element: <DashboardPage />, path: routeEnum.ResetPassword },
      { element: <DashboardPage />, path: routeEnum.Home },
      { element: <DashboardPage />, path: routeEnum.VerifyInvitation },
      { element: <NotFound />, path: routeEnum.FallBack },
      { element: <InvitationExpiryPage />, path: routeEnum.InvitationExpiry },

      {
        children: [
          {
            element: <OrganisationBooking />,
            path: organisationEnum.Booking,
          },
          {
            element: <OrganisationInfo />,
            path: routeEnum.Info,
          },
        ],
        element: <OrganisationInfoPage />,
        path: routeEnum.OrganisationInfo,
      },

      {
        children: [
          {
            children: [
              { element: <ProfileInfo />, index: true },
              { element: <Reservations />, path: userInfoEnum.Reservations },
              {
                element: <ProfileInfo />,
                path: routeEnum.Info,
              },
            ],
            element: <UserInfoPage />,
            path: routeEnum.UserInfo,
          },
        ],
        element: <RequireAuth />,
      },
    ],
    element: <RootLayout />,
  },
  {
    children: [{ element: <CookiePolicy />, path: routeEnum.CookiePolicy }],
    element: <StandAloneLayout />,
  },
]);
